import type { GeoInfo } from './tipos'

const GEO_CACHE_KEY = 'biomo_geo_data'

/**
 * Busca geolocalização via /api/geo com cache em sessionStorage
 */
export async function fetchGeoInfo(): Promise<GeoInfo> {
  if (typeof window === 'undefined') {
    return { ip: null, country: null, region: null, city: null, timezone: null }
  }

  // Verificar cache no sessionStorage
  try {
    const cached = sessionStorage.getItem(GEO_CACHE_KEY)
    if (cached) {
      return JSON.parse(cached) as GeoInfo
    }
  } catch {
    // sessionStorage indisponível
  }

  try {
    const response = await fetch('/api/geo')
    if (!response.ok) throw new Error('Geo API error')

    const data = await response.json()
    const geoInfo: GeoInfo = {
      ip: data.ip || null,
      country: data.country || null,
      region: data.region || null,
      city: data.city || null,
      timezone: data.timezone || Intl.DateTimeFormat().resolvedOptions().timeZone || null,
    }

    // Salvar no sessionStorage
    try {
      sessionStorage.setItem(GEO_CACHE_KEY, JSON.stringify(geoInfo))
    } catch {
      // sessionStorage indisponível
    }

    return geoInfo
  } catch {
    return {
      ip: null,
      country: null,
      region: null,
      city: null,
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone || null,
    }
  }
}
